import React from 'react';
import { connect } from 'react-redux';
import { fetchCategoriesIfNeeded, excludeDeprecated } from 'common/ducks/categories';
import { fetchDrafts } from 'pap0/ducks';
import Categories from 'pap0/components/categories';

Categories.need = [ fetchCategoriesIfNeeded ];

const mapStateToProps = (
  { categories: { data }, user, pap0 }, { params: { categorySlug }, route: { path } }
) => {
  /* filter out deprecated categories/sub-categories */
  let categories = excludeDeprecated(data)
  /* filter out 1-1 categories */
  categories = categories.filter(c => !c.is_one_to_one)

  /* /popular/ route: filter only popular sub-categories */
  if (path == 'popular') {
    categories = categories.reduce((acc, cat) => {
      const popularSubcats = cat.sub_categories.filter(subcat => subcat['is_popular'])
      if (popularSubcats.length == 0) {
        return acc
      }
      return acc.concat({...cat, sub_categories: popularSubcats})
    }, [])

  /* /:categorySlug/ route: filter only sub-categories of the given category */
  } else if (categorySlug) {
    categories = categories.filter(c => c.slug == categorySlug)
  }

  return {
    categories,
    user: user.profile_data,
    drafts: pap0.drafts,
    popularOnly: path === "popular"
  }
}

export default connect(mapStateToProps, {
  fetchCategoriesIfNeeded,
  fetchDrafts
})(Categories);



// WEBPACK FOOTER //
// ./pap0/containers/categories.js